export default "__VITE_ASSET__WZ6x8O0F__"